import React from 'react';
import { connect } from 'react-redux'

import { Link } from "react-router-dom"

class Nav extends React.Component {
  componentDidMount() {
    console.log(this.props.form)
  }

  constructor(props) {
    super(props)
    this.state = {
      isHovering: false
    }
  }

  componentDidUpdate = () => {
  }

  handleMouseEnter = () => {
    this.setState({ isHovering: true });
  }

  handleMouseLeave = () => {
    this.setState({ isHovering: false });
  }

  renderDropDown = () => {
    if (this.state.isHovering) {
      return (
        // The wrapper carries the offset as padding (not margin) so the pointer
        // never crosses a dead gap on its way from the button into the panel —
        // a margin here closes the dropdown before it can be clicked.
        <div className="absolute right-0 top-full pt-2 w-72 z-40">
        <div
          className="w-full rounded-2xl bg-white shadow-lg border border-[#E5E7EB] p-4"
          style={{ color: '#1F2937' }}
        >
          <div className="pb-3 border-b border-[#E5E7EB]">
            <p
              className="text-[10px] uppercase tracking-widest font-bold"
              style={{ color: '#5B3FE0' }}
            >
              Your Brokers
            </p>
            <p className="mt-1 text-base font-bold text-[#1F2937]">Ryan & Paul Pappas</p>
          </div>

          <div className="py-3 text-sm text-[#6B7280] leading-relaxed space-y-2">
            <p>
              LoanGateway is your secure portal for sharing the personal details we need
              to help with your loan.
            </p>
            <p>Give us a call if you need any further assistance.</p>
          </div>

          <div className="pt-3 border-t border-[#E5E7EB] flex items-center gap-4 text-xs font-semibold">
            <Link to={`/privacy-loangateway`} target="_blank" style={{ color: '#5B3FE0' }}>
              Privacy Policy
            </Link>
          </div>
        </div>
        </div>
      )

    } else {
      return (null)
    }
  }

  renderProgress = () => {
    var progress_bars = []
    var progress_bar_count = 0
    if (this.props.form == "General_Details") { progress_bar_count = 1 }
    if (this.props.form == "Address_3y") { progress_bar_count = 2 }
    if (this.props.form == "Employment_Details") { progress_bar_count = 3 }
    if (this.props.form == "Income") { progress_bar_count = 4 }
    if (this.props.form == "Liabilities_Debts") { progress_bar_count = 5 }
    if (this.props.form == "Assets") { progress_bar_count = 6 }
    if (this.props.form == "Loan_Requirements") { progress_bar_count = 7 }


    for (let index = 0; index < progress_bar_count; index++) {
      progress_bars.push(
        <span
          key={`done-${index}`}
          className="h-1.5 w-5 rounded-full"
          style={{ backgroundColor: '#7C5CFC' }}
        />
      )
    }

    if (progress_bar_count < 7) {
      for (let index = 0; index < (7 - progress_bar_count); index++) {
        progress_bars.push(
          <span
            key={`todo-${index}`}
            className="h-1.5 w-2 rounded-full"
            style={{ backgroundColor: '#E5E7EB' }}
          />
        )
      }
    }

    if (this.props.showProgress == "true") {
      return (
        <div className="border-t border-[#E5E7EB] bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-1.5 justify-center">
            {progress_bars}
          </div>
        </div>
      )
    } else {
      return (null)
    }
  }


  render() {
    return (
      <div className="sticky top-0 z-30">
        {/* Mobile dark header */}
        <div
          className="lg:hidden flex items-center justify-between px-4 h-14"
          style={{ backgroundColor: '#1A1D2A' }}
        >
          <Link to={`/dashboard/${this.props.id}`} className="flex items-center">
            <img
              src={process.env.PUBLIC_URL + '/images/logos/light_transparent.png'}
              alt="LoanGateway"
              className="h-6 w-auto"
            />
          </Link>

          <a
            href="tel:0292310511"
            aria-label="Call 02 9231 0511"
            className="inline-flex items-center justify-center h-9 w-9 rounded-full"
            style={{ backgroundColor: 'rgba(124, 92, 252, 0.2)', color: '#C4B5FD' }}
          >
            <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 4a2 2 0 012-2h2.3a1 1 0 01.95.68l1.1 3.3a1 1 0 01-.5 1.2l-1.7.85a11 11 0 005.5 5.5l.86-1.7a1 1 0 011.2-.5l3.3 1.1a1 1 0 01.68.95V16a2 2 0 01-2 2h-1C7.6 18 2 12.4 2 5V4z" />
            </svg>
          </a>
        </div>

        {/* Desktop light header */}
        <div className="hidden lg:block bg-white border-b border-[#E5E7EB]">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
            <Link to={`/dashboard/${this.props.id}`} className="flex items-center">
              <img
                src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'}
                alt="LoanGateway"
                className="h-7 w-auto"
              />
            </Link>

            <div className="flex items-center gap-3">
              <div
                className="relative"
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
              >
                <button
                  type="button"
                  className="inline-flex items-center gap-2 rounded-full px-2 py-1 transition-colors"
                  style={{ backgroundColor: '#F5F6FA' }}
                >
                  <img
                    src={process.env.PUBLIC_URL + '/images/brokers.png'}
                    alt="Your brokers"
                    className="h-7 w-7 rounded-full object-cover"
                  />
                  <span className="text-xs font-semibold pr-2 text-[#1F2937]">
                    Your Brokers
                  </span>
                </button>
                {this.renderDropDown()}
              </div>

              <span className="text-sm text-[#6B7280] font-light hidden xl:inline">
                Need help?
              </span>
              <a
                href="tel:0292310511"
                className="inline-flex items-center gap-2 rounded-xl border border-[#E5E7EB] px-3 py-2 text-sm font-semibold text-[#1F2937] hover:bg-[#F5F6FA] transition-colors"
              >
                <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" style={{ color: '#5B3FE0' }}>
                  <path d="M2 4a2 2 0 012-2h2.3a1 1 0 01.95.68l1.1 3.3a1 1 0 01-.5 1.2l-1.7.85a11 11 0 005.5 5.5l.86-1.7a1 1 0 011.2-.5l3.3 1.1a1 1 0 01.68.95V16a2 2 0 01-2 2h-1C7.6 18 2 12.4 2 5V4z" />
                </svg>
                Call 02 9231 0511
              </a>
            </div>
          </div>
        </div>

        {this.renderProgress()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return { id: state.id }
}

export default connect(mapStateToProps, {})(Nav)
